<!--
                               o8o                 .
                               `"'               .o8
   .oooo.o  .ooooo.  oooo d8b oooo  oo.ooooo.  .o888oo
  d88(  "8 d88' `"Y8 `888""8P `888   888' `88b   888
  `"Y88b.  888        888      888   888   888   888
  o.  )88b 888   .o8  888      888   888   888   888 .
  8""888P' `Y8bod8P' d888b    o888o  888bod8P'   "888"
                                     888
                                    o888o
 -->

<script>

import find from 'lodash/find'

export default {

  name: 'LangSwitcher',

  data () {
    return {
      opened: false,
      langs: [
        { id: 'ua', label: 'ukr' },
        { id: 'en', label: 'eng' },
        // { id: 'ru', label: 'rus' }
      ]
    }
  },

  computed: {
    currentLang () {
      return find(this.langs, { id: this.$store.state.app.lang } )
    },

    availableLangs () {
      return this.langs.filter(lang => lang.id !== this.currentLang.id)
    },

    isMobile(){
      return this.$store.getters.isMobile
    },

    menuOpenMobile(){
      return (this.$store.getters.isPopupOpened && this.isMobile)
    }

  },

  created () {
    this.$root.$on('click', () => this.opened = false)
  },

  beforeDestroy () {
    this.$root.$off('click')
  },

  methods: {
    getLangUrl (newLang) {
      const route = this.$route

      if (route.name === 'home') return '/' + newLang

      const lang = route.params.lang
      const path = route.fullPath
      const url = path.replace(new RegExp(`\/${lang}`), '/' + newLang)

      return url
    },

    onLangChange () {
      this.$store.commit('startLoading', true);

      this.opened = false;

      if (this.$store.getters.isPopupOpened) {
        this.$store.dispatch('closePopup', true)
      }
    }
  }

}

</script>


<!--

  oooo                                                  .
  `888                                                .o8
   888   .oooo.   oooo    ooo  .ooooo.  oooo  oooo  .o888oo
   888  `P  )88b   `88.  .8'  d88' `88b `888  `888    888
   888   .oP"888    `88..8'   888   888  888   888    888
   888  d8(  888     `888'    888   888  888   888    888 .
  o888o `Y888""8o     .8'     `Y8bod8P'  `V88V"V8P'   "888"
                  .o..P'
                  `Y8P'
 -->


<template lang="pug">

.lang-switcher(@click.stop="", :class="[menuOpenMobile ? 'lang-switcher--open' : '']")
  .lang-button.lang-button--main(type="button" @click="opened = !opened")
    .lang-button__content
      span.lang-button__label {{ $t(currentLang.label) }}

  transition(name="fade")
    .langs(v-if="opened || menuOpenMobile")
      router-link.lang-button(v-for="lang in availableLangs", :key="lang.id", :to="getLangUrl(lang.id)", @click.native="onLangChange")
        .lang-button__content
          span.lang-button__label {{ $t(lang.label) }}

</template>


<!--
               .               oooo
             .o8               `888
   .oooo.o .o888oo oooo    ooo  888   .ooooo.   .oooo.o
  d88(  "8   888    `88.  .8'   888  d88' `88b d88(  "8
  `"Y88b.    888     `88..8'    888  888ooo888 `"Y88b.
  o.  )88b   888 .    `888'     888  888    .o o.  )88b
  8""888P'   "888"     .8'     o888o `Y8bod8P' 8""888P'
                   .o..P'
                   `Y8P'
 -->


<style lang="stylus" scoped>
.lang-switcher
  position relative
  display flex

  +mobile()
    display: none

  &--open
    display: flex

.lang-button
  display block
  color inherit
  cursor: pointer

  +desktop()
    &:hover
      color orange

  &__content
    display flex
    justify-content center
    align-items center
    width 100%
    height 100%
    padding 21px

  &__label
    font-size 14px
    font-weight normal
    transition color .2s

  &--main

    .lang-button__label
        font-weight: 500

.langs
  position absolute
  top 0
  right 100%
  display flex
  height 100%
  color inherit

  +mobile()
    border-radius: 10%

.fade-enter
.fade-leave-to
  transform translateX(20px)
  opacity 0
  visibility hidden

.fade-enter-active
.fade-leave-active
  transition transform .5s, opacity .5s, visibility .5s

</style>



// WEBPACK FOOTER //
// lang-switcher.vue?256148f0